import fpApiUtil from "./fp-api-util";

const BASE = "factoryplan/master/stock/stocks";

const getAll = (params) => fpApiUtil.postParams(BASE, params);
const upsert = (changes) => fpApiUtil.postChanges(`${BASE}/save`, changes);
const remove = (changes) => fpApiUtil.postChanges(`${BASE}/delete`, changes);

const fpStockService = { getAll, upsert, remove };
export default fpStockService;
